import { render, staticRenderFns } from "./sendOrderData.vue?vue&type=template&id=8f78c736&"
import script from "./sendOrderData.vue?vue&type=script&lang=js&"
export * from "./sendOrderData.vue?vue&type=script&lang=js&"
import style0 from "./sendOrderData.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
